import { render, staticRenderFns } from "./ProgressReportParameters.vue?vue&type=template&id=610804f5&scoped=true"
import script from "./ProgressReportParameters.vue?vue&type=script&lang=js"
export * from "./ProgressReportParameters.vue?vue&type=script&lang=js"
import style0 from "./ProgressReportParameters.vue?vue&type=style&index=0&id=610804f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610804f5",
  null
  
)

export default component.exports